package gr.tech.GRAttestation.sections.store

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.models.stores.StorePreviewDTO
import gr.tech.GRAttestation.styles.grstyles.Theme
import gr.tech.GRAttestation.styles.store.*
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

@Composable
fun StoreInfoBanner(store: StorePreviewDTO?) {
    Div(attrs = StoreInfoBannerStyle.toModifier().margin(bottom = 20.px).toAttrs()) {
        Div(attrs = StoreInfoBannerInnerStyle.toModifier().toAttrs()) {

            // Left — store name, location ID badge, address
            Column(modifier = Modifier.gap(0.px)) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.gap(10.px)
                ) {
                    SpanText(
                        text = store?.storeName ?: "—",
                        modifier = StoreInfoNameStyle.toModifier()
                    )
                    SpanText(
                        text = store?.locationId ?: "",
                        modifier = Modifier.classNames("badge").backgroundColor(Theme.MediumGreen.rgb)
                            .color(Theme.DarkGreen.rgb)
                    )
                }
                SpanText(
                    text = store?.let { "${it.storeAddress}, ${it.storeCity}, ${it.storeState} ${it.storeZip}" } ?: "",
                    modifier = StoreInfoAddressStyle.toModifier()
                )
            }

            // Right — partner info
            Column(
                modifier = StoreInfoPartnerStyle.toModifier().gap(2.px),
                horizontalAlignment = Alignment.End
            ) {
                SpanText(text = "Partner: Green Rebates, LLC")
                SpanText(text = "ETO Grow Light Fixture Program 2026")
            }
        }
    }
}